import actionTypes from '../../constants/ActionTypes';
import { buildUrl } from '../helpers';
import { request } from './request';

export default () => next => action => {
  // Ignore all non FETCH actions
  if (action.type !== actionTypes.FETCH) {
    return next(action);
  }
  const { key, url, data, params, baseUrl = '', method = 'get' } = action;

  // Fire IN_PROGRESS event as the first event of fetch
  next({ type: actionTypes.FETCH_IN_PROGRESS, key });

  (async function invoke() {
    try {
      const res = await request({ method, url: buildUrl(baseUrl, url), data, params });
      next({ type: actionTypes.FETCH_SUCCESS, key, data: res.data }); // Fire FETCH_SUCCESS on fetch call success
    } catch (e) {
      next({ type: actionTypes.FETCH_FAILED, key, error: e }); // Fire FETCH_FAILED on fetch call failure
    }
  })().then();
};
